export enum AnalysisFilterKeys {
    DirectManagerId = "DirectManagerId",
    Gender = "Gender",
    Nationality = "Nationality",
    DateOfBirth = "DOB",
    DateOfJoining = "JOD",
    BandLevel = "BandLevel",
    PerformanceRating = "PerformanceRate",
    JobGrade = "JobGrade",
    Generation = "Generation",
    AgeGroups = "AgeGroup",
    TenureGroups = "TenureGroup",
    JobRole = "JobRole",
    TimeFrame = "Timeframe",
    EntityId = "Entity",
    SurveyStatus = "SurveyStatus",
    Country = "Country",
    Industry = "Industry",
    Phase = "Phase",
    Criteria = "criteria",
    IncludeExtraDrivers = "ExtraDriver",
}
